export const entityStatuses = {
    widget: {
        enabled: 1,
        disabled: 2
    }
}
